export class TicketSoporte {
  constructor(public id: any, public asunto: string, public descripcion: string, public email: string, public nombre: string) {}
}

export class InfoVersion {
  constructor(public uuid: string, public modulo: string, public version: string, public fecha_version: string, public tipo: string, public css_tipo: string, public titulo: string, public descripcion: string, public isCollapsed: number, public visible: number) {}
}
